//文字コードはutf-8

// Swiper は lib/swiper-bundle.min.js（グローバル window.Swiper）を使用

/* 事業紹介カルーセル（Swiper）
 * - 矢印 / ドットで移動、ドットは現在地を反映
 * - 自動再生 + 一時停止ボタン
 * - PCは左端揃え、SPは中央寄せ
 * - ループ（無限）再生
 * - 既存の BEM クラスをそのまま Swiper の各パーツに割り当てる
 *   （swiper- 系のケバブクラスをマークアップに足さない → BEMチェックを汚さない）
========================================================*/
export function initCarousel() {
    const root = document.getElementById('js-businessCarousel');
    if (!root || !window.Swiper) return;

    const section = root.closest('.business') || document;
    const prevBtn = section.querySelector('[data-slider="prev"]');
    const nextBtn = section.querySelector('[data-slider="next"]');
    const toggleBtn = section.querySelector('[data-slider="toggle"]');
    const dotsWrap = section.querySelector('.business__dots');

    const AUTOPLAY_MS = 4500;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const swiper = new window.Swiper(root, {
        // modules 指定は不要（swiper-bundle が全モジュールを内包）
        // 既存 BEM クラスを Swiper のラッパー / スライドとして使う
        wrapperClass: 'business__track',
        slideClass: 'business__slide',
        slidesPerView: 'auto',
        loop: true,
        speed: reduceMotion ? 0 : 600,
        // ベース = SP（中央寄せ・gap 16px）
        centeredSlides: true,
        spaceBetween: 16,
        breakpoints: {
            // PC = 左端揃え・gap 40px
            769: {
                centeredSlides: false,
                spaceBetween: 40,
            },
        },
        autoplay: {
            delay: AUTOPLAY_MS,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
        },
        pagination: dotsWrap ? {
            el: dotsWrap,
            clickable: true,
            bulletClass: 'business__dot',
            bulletActiveClass: 'business__dot--active',
            renderBullet: (index, className) =>
                `<button type="button" class="${className}" aria-label="${index + 1}番目の事業を表示"></button>`,
        } : false,
    });

    // ---- 自動再生 / 一時停止トグル ----
    if (toggleBtn) {
        const reflect = (paused) => {
            toggleBtn.classList.toggle('is-paused', paused);
            toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
            toggleBtn.setAttribute('aria-label', paused ? '自動再生を開始' : '自動再生を停止');
        };

        toggleBtn.addEventListener('click', () => {
            if (swiper.autoplay.running && !swiper.autoplay.paused) {
                swiper.autoplay.stop();
                reflect(true);
            } else {
                swiper.autoplay.start();
                reflect(false);
            }
        });

        // モーション低減環境では自動再生を止めた状態で開始
        if (reduceMotion) {
            swiper.autoplay.stop();
            reflect(true);
        } else {
            reflect(false);
        }
    } else if (reduceMotion) {
        swiper.autoplay.stop();
    }
}
